import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import { CountUp } from 'countup.js'

Alpine.plugin(intersect)
Alpine.start()

function xCountUp(duration = 3) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const animateNumber = new CountUp(this.$el, this.number, {
        duration: duration,
        separator: '.',
    });

    if (!animateNumber.error) {
        animateNumber.start();
    }
}

document.querySelector('body').addEventListener('cookies:saved', function (event) {
    if (event.detail.includes('analytics')) {
        var script = document.createElement('script')
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + window.GOOGLE_ANALYTICS_ID
        script.async = true

        document.body.appendChild(script)
    }
})

window.Alpine = Alpine
window.xCountUp = xCountUp
